import React from "react";
import classNames from "classnames";
interface TitleWithLineProps {
  primaryTitle: string;
  secondaryTitle?: string;
  hideLine?: boolean;
  width?: string;
  nowrap?: boolean;
}

const TitleWithLine: React.FC<TitleWithLineProps> = ({
  primaryTitle,
  hideLine,
  secondaryTitle,
  width,
  nowrap,
}) => (
  <span className={"flex items-center justify-center pt-[18px] md:pt-[30px]"}>
    <span
      className={classNames("h-[1px] w-[20%] bg-primary md:w-full", {
        "hidden md:inline": hideLine,
      })}
    ></span>
    <span
      className={classNames(
        "mx-1 w-fit text-center text-[12px] text-[#272D4E] sm:mx-4 md:text-[18px]",
        {
          "sm:whitespace-nowrap": nowrap ?? true,
          "sm:text-[14px]": width === undefined,
        }
      )}
      style={{ width: width || "fit-content" }}
    >
      {primaryTitle} &nbsp;
      <span className={"text-primary sm:whitespace-nowrap md:text-[18px]"}>
        {secondaryTitle}
      </span>
    </span>
    <span
      className={classNames("h-[1px] w-[20%] bg-primary md:w-full", {
        "hidden md:inline": hideLine,
      })}
    ></span>
  </span>
);
export default TitleWithLine;
